export const model = {
    id: null,
    name: '',   
    start: '',
    end: '',
    services: '',
    created_at: '',
    updated_at: ''
};
